module.exports = __webpack_public_path__ + "static/fonts/iconfont.60dc148a.woff2";